/* ============================================================
   PINTÓN — popup-analytics.js
   Bridge popup events → GA4 / Meta Pixel / TikTok Pixel
   Listens to CustomEvents emitted by popup-triggers.js:
   popup:popup_show · popup:popup_close · popup:popup_submit
   ============================================================ */
(function () {
  'use strict';

  const sendGA = (event, params) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...params });
    }
  };

  const sendMeta = (event, params) => {
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', event, params);
    }
  };

  const sendTikTok = (event, params) => {
    if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
      window.ttq.track(event, params);
    }
  };

  const dispatch = (event, payload) => {
    sendGA(event, payload);
    sendMeta(event, payload);
    sendTikTok(event, payload);
  };

  document.addEventListener('popup:popup_show', (e) => {
    dispatch('popup_show', { popup_id: e.detail.id, trigger: e.detail.trigger });
  });

  document.addEventListener('popup:popup_close', (e) => {
    dispatch('popup_close', { popup_id: e.detail.id, reason: e.detail.reason });
  });

  document.addEventListener('popup:popup_submit', (e) => {
    dispatch('popup_submit', { popup_id: e.detail.id, provider: e.detail.provider });
    // GA4 lead conversion event
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { popup_id: e.detail.id, value: 1, currency: 'USD' });
    }
  });

  // Cart events from theme.js
  document.addEventListener('cart:item-added', () => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'add_to_cart', { currency: 'USD' });
    }
    if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart');
  });
})();
